{
  "settings": {
    "title": "Account at settings",
    "lead": "Ang iyong mga detalye, wika, notification at data.",
    "signedInAs": "Naka-sign in bilang {email}",
    "emailVerified": "Kumpirmado ang email",
    "emailUnverified": "Hindi pa kumpirmado ang email",
    "guestTitle": "Mag-sign in para sa higit pa",
    "guestBody": "Sa isang account, makakapagparehistro ka sa mga programa, masusundan ang mga opisina at ang iyong barangay, makakatanggap ng notification, at masusubaybayan ang iyong mga ulat.",
    "profileTitle": "Ang iyong mga detalye",
    "profileLead": "Ginagamit ang mga ito para punan ang mga form ng rehistro. Lagi mo itong masusuri bago ipadala.",
    "moreDetails": "Iba pang detalye para sa rehistro",
    "moreDetailsHint": "Opsyonal. May mga programang humihingi nito.",
    "address": "Tirahan",
    "birthdate": "Petsa ng kapanganakan",
    "sex": "Kasarian",
    "sexChoose": "Pumili",
    "sex_female": "Babae",
    "sex_male": "Lalaki",
    "sex_prefer_not_to_say": "Ayaw sabihin",
    "rsbsa": "Numero ng RSBSA",
    "rsbsaHint": "Registry System for Basic Sectors in Agriculture. Nakatutulong para maging kuwalipikado ang magsasaka sa ayuda.",
    "seniorPwdId": "Numero ng senior citizen o PWD ID",
    "school": "Paaralan",
    "saveProfile": "I-save ang mga detalye",
    "profileSaved": "Na-save ang iyong mga detalye.",
    "languageTitle": "Wika",
    "languageLead": "Lumalabas ang mga post ng opisina sa wikang ginamit ng opisina.",
    "english": "English",
    "filipino": "Filipino",
    "displayTitle": "Display",
    "largeText": "Mas malaking teksto",
    "highContrast": "Mataas na contrast",
    "lowData": "Low-data mode",
    "lowDataHint": "Itinatago ang mga larawan sa post at naglo-load lang ang mapa kapag pinindot mo.",
    "notificationsTitle": "Mga notification",
    "notificationsLead": "Mga alerto sa teleponong ito para sa bagong post ng mga opisinang sinusundan mo, balita sa rehistro at mga paalala.",
    "pushOnDevice": "Notification sa device na ito",
    "pushIsOn": "Naka-on",
    "pushIsOff": "Naka-off",
    "pushTurnOn": "I-on",
    "pushTurnOff": "I-off",
    "pushTurnedOff": "Naka-off ang notification sa device na ito.",
    "pushNotConfigured": "Hindi pa available ang notification. Hindi pa ito naise-set up ng LGU.",
    "manageFollowing": "Piliin ang mga sinusundan mo",
    "openInbox": "Buksan ang mga notification",
    "passwordTitle": "Password",
    "currentPassword": "Kasalukuyang password",
    "changePassword": "Palitan ang password",
    "passwordUpdated": "Napalitan ang password. Na-sign out ka sa iba mo pang device.",
    "dataTitle": "Ang iyong data",
    "dataLead": "Sa ilalim ng Data Privacy Act (RA 10173), maaari kang kumuha ng kopya ng iyong data o burahin ang iyong account anumang oras.",
    "download": "I-download ang aking data",
    "downloadHint": "Isang file ng iyong mga detalye, rehistro, sinusundan at mga ulat.",
    "downloading": "Inihahanda…",
    "downloaded": "Na-download ang file ng iyong data.",
    "deleteTitle": "Burahin ang aking account",
    "deleteBody": "Permanenteng mabubura ang iyong account at personal na detalye. Makakansela ang iyong mga paparating na rehistro. Mananatili sa LGU bilang opisyal na rekord ang mga ulat ng emergency at pinsala sa pananim na ipinadala mo, pero hindi na ito nakaugnay sa iyo.",
    "deleteConfirmLabel": "Ilagay ang iyong password para kumpirmahin",
    "deleteConfirm": "Burahin nang permanente",
    "deleting": "Binubura…",
    "deleted": "Nabura na ang iyong account.",
    "staffNoDelete": "Ang mga staff account ay inaalis ng administrator ng LGU.",
    "workTitle": "Trabaho sa LGU",
    "signedOut": "Naka-sign out ka na.",
    "smsAlertsTitle": "Agarang abiso sa SMS",
    "smsAlertsHint": "Mga text message mula sa LGU tuwing may emergency, ipinapadala sa iyong mobile number. Ginagamit lang ang iyong numero para sa mga opisyal na abiso.",
    "smsAlertsNoMobile": "Idagdag ang iyong mobile number sa Ang iyong mga detalye para makatanggap ng agarang abiso sa SMS.",
    "smsAlertsOnSaved": "Makakatanggap ka ng agarang abiso sa SMS.",
    "smsAlertsOffSaved": "Hindi ka makakatanggap ng agarang abiso sa SMS. Lalabas pa rin ang mga ito sa app."
  },
  "privacy": {
    "title": "Abiso sa privacy",
    "lead": "Kung paano pinangangasiwaan ng {lgu} ang iyong personal na impormasyon sa app na ito, ayon sa Data Privacy Act of 2012 (RA 10173).",
    "whoTitle": "Sino ang may pananagutan",
    "whoBody": "Ang {lgu} ang personal information controller ng app na ito. Tumatakbo ang {app} sa iLi, isang platform na ginagamit ng LGU para sa mga serbisyo nito. Nakatago ang iyong data sa database na para lamang sa LGU na ito.",
    "collectTitle": "Ano ang kinokolekta namin",
    "collect1": "Mga detalye ng account na ibinigay mo: pangalan, email, numero ng mobile, barangay, at anumang opsyonal na detalye na idinagdag mo (tirahan, petsa ng kapanganakan, kasarian, numero ng RSBSA, numero ng senior o PWD ID, paaralan).",
    "collect2": "Ang iyong mga rehistro sa mga programa at aktibidad, at ang mga sagot sa bawat form ng rehistro.",
    "collect3": "Mga ulat ng emergency: ang lokasyong itinuro mo, mga larawan, paglalarawan, at ang iyong pangalan at numero ng mobile.",
    "collect4": "Mga ulat ng pinsala sa pananim: lokasyon ng sakahan, mga larawan, mga pananim at lawak ng apektado, at ang iyong numero ng RSBSA kung ibinigay mo.",
    "collect5": "Mga opisina, barangay at kategoryang sinusundan mo, at ang iyong settings sa notification, kasama ang address ng push notification ng device na ito.",
    "collect6": "Isang random na ID para sa device na ito, ginagamit lamang para pigilan ang pang-aabuso tulad ng paulit-ulit na pekeng ulat.",
    "locationNote": "Nase-save lang ang iyong lokasyon sa ulat na ipinadala mo. Hindi kailanman sinusubaybayan ng app kung nasaan ka.",
    "whyTitle": "Bakit namin ito ginagamit",
    "why1": "Para patakbuhin ang mga rehistrong sinalihan mo at padalhan ka ng ticket, balita at paalala.",
    "why2": "Para tumugon sa emergency at magpadala ng tulong sa tamang lugar.",
    "why3": "Para patunayan ang pinsala sa pananim at ihanda ang ulat ng pinsala para sa ayuda mula sa probinsya at sa Department of Agriculture.",
    "why4": "Para abisuhan ka tungkol sa mga opisina at barangay na sinusundan mo.",
    "shareTitle": "Sino ang nakakakita nito",
    "shareBody": "Ang staff lamang ng opisinang humahawak sa iyong rehistro o ulat ang nakakakita nito. Itinatala sa audit log ang bawat aksyon ng staff. Ibinabahagi sa provincial agriculture office at sa Department of Agriculture ang mga napatunayang ulat ng pinsala sa pananim. Hindi namin ibinebenta ang iyong data o ginagamit para sa advertising.",
    "keepTitle": "Gaano katagal namin ito itinatago",
    "keepBody": "Mananatili ang iyong account hanggang burahin mo ito. Itinatago ang mga rehistro bilang rekord ng LGU sa bawat programa. Ang mga ulat ng emergency at pinsala sa pananim ay opisyal na rekord ng pamahalaan at itinatago ayon sa mga patakaran sa rekord, kahit burahin mo na ang iyong account; hindi na ito nakaugnay sa iyo.",
    "rightsTitle": "Ang iyong mga karapatan",
    "rightsBody": "Sa ilalim ng RA 10173, may karapatan kang malaman, makita ang iyong data, itama ito, tumutol, ipabura o ipa-block ito, sa data portability, sa danyos, at magsampa ng reklamo sa National Privacy Commission (privacy.gov.ph).",
    "controlTitle": "I-download o burahin ang iyong data",
    "controlBody": "Pumunta sa Account at settings → Ang iyong data. Doon mo maida-download ang kopya ng iyong data o mabubura ang iyong account anumang oras.",
    "controlLink": "Buksan ang Ang iyong data",
    "dpoTitle": "Data Protection Officer",
    "dpoLead": "Para sa mga tanong o kahilingan tungkol sa iyong personal na data, makipag-ugnayan sa Data Protection Officer ng LGU.",
    "dpoPending": "Ipo-post dito ang contact details ng Data Protection Officer ng LGU. Habang wala pa, bumisita o tumawag sa {lgu}.",
    "dpoName": "Pangalan",
    "dpoEmail": "Email",
    "dpoPhone": "Telepono"
  },
  "about": {
    "title": "Tungkol dito",
    "lgu": "Pinagsasama ng {app} ang bawat opisina ng {lgu}, {province} sa iisang app: mga iskedyul, programa, rehistro, alerto, at ulat ng emergency.",
    "whatTitle": "Ano ang magagawa mo",
    "what1": "Makita ang mga iskedyul, programa at anunsyo ng bawat opisina sa iisang feed.",
    "what2": "Magparehistro sa ilang pindot at makakuha ng QR ticket.",
    "what3": "Sundan ang mga opisina at ang iyong barangay, at makatanggap ng notification.",
    "what4": "Hanapin ang pinakamalapit na evacuation site at mga hotline, kahit offline.",
    "what5": "Mag-ulat ng emergency at nasirang pananim.",
    "iliTitle": "Tungkol sa iLi",
    "iliTagline": "Ang iyong bayan, sa iisang app.",
    "iliMeaning": "Ang ili ay nangangahulugang “bayan” o “sariling bayan” sa Ilocano at sa mga wika ng Cordillera. Mababasa rin ang pangalan bilang information · Local · integrated.",
    "iliBody": "Ang iLi ay isang civic app platform para sa mga lokal na pamahalaan sa Pilipinas. Bawat LGU ay may sariling kopya, at hiwalay ang data ng bawat isa.",
    "linksTitle": "Iba pa"
  },
  "more": {
    "hello": "Kumusta, {name}",
    "guestLead": "Mag-sign in para magparehistro, sumunod sa mga opisina at makatanggap ng notification."
  },
  "notFound": {
    "lead": "Maaaring luma na ang link, o inilipat na ang pahina.",
    "hotlines": "Tingnan ang mga hotline"
  }
}
